import {Environment} from '../environment';

export const environment: Environment = {
    apiUrl: 'https://dev-api-becvary.techcrowd.space',
    development: false,
};
